<template>
	<div id="app">
		<router-view :key="$route.fullPath"></router-view>
	</div>
</template>

<script>
import gql from "graphql-tag"
import mixins from "./mixins/mixins"
import listMixins from "./mixins/listMixins"
import { mapMutations, mapGetters } from "vuex"
export default {
	name: "App",
	mixins: [mixins, listMixins],
	metaInfo: {
		title: "Tickets online",
		titleTemplate: "%s | CobraTicket"
	},

	beforeMount() {
		this.loadMe()
	},
	computed: {
		...mapGetters(["isAuthenticated"])
	},
	methods: {
		...mapMutations(["updateLoggedUser"]),
		loadMe() {
			if (this.isAuthenticated) {
				this.$apollo
					.query({
						query: gql`
							query {
								userLogged {
									id
									name
									lastname
									email
									phone {
										countryCode
										national
										international
										type
										validated
									}
									document {
										type
										number
									}
									isPromotor
								}
							}
						`,
						fetchPolicy: "no-cache"
					})
					.then(({ data }) => {
						this.updateLoggedUser(data.userLogged)
					})
					.catch(() => {
						this.$router.push("/logout")
					})
			} else {
				// this.$router.push("/")
			}
		}
	}
}
</script>
